import React, { useEffect, useState } from "react";
import axios from "axios";
import CardForUsers from "../Cards/CardForUsers";
import "./CardForUsers.css";
import { useHistory } from "react-router-dom";
import BASE_URL from "components/BaseUrl/apiConfig";

const UserMessageCounts = () => {
  const [messageCounts, setMessageCounts] = useState({});
  const history = useHistory();

  useEffect(() => {
    if (!localStorage.getItem("userData")) {
      history.push("/login");
    }
  }, [history]);

  useEffect(() => {
    const storedUserData = localStorage.getItem("userData");
    let groupId = "";

    if (storedUserData) {
      const userData = JSON.parse(storedUserData);
      groupId = userData.groupId;
    }
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/Analytics/GetMessageCounts?groupId=${groupId}`
        );
        setMessageCounts(response.data);
      } catch (error) {
        console.error("Error fetching message counts:", error);
      }
    };

    fetchData();
  }, []);

  const totalMessages = Object.values(messageCounts)
    .filter((value) => typeof value === "number")
    .reduce((total, count) => total + count, 0);

  return (
    <div className="relative">
      <div className="mx-auto w-full">
        <div className="flex flex-wrap -mx-4">
          {/* Card for total messages */}
          <div className="custom-card px-4  ">
            <CardForUsers
              statTitle="All Time"
              messageTypes={{
                "Total Messages": totalMessages || 0,
                Email: messageCounts.Email || 0,
                Facebook: messageCounts.Facebook || 0,
                LinkedIn: messageCounts.LinkedIn || 0,
                Others: messageCounts.Others || 0,
              }}
              statIconName="fas fa-envelope"
              statIconColor="bg-red-500"
              statTitleColor="text-green-500"
              statIconStyle="bg-red-500"
            />
          </div>

          {/* Cards for each user */}
          {Object.entries(messageCounts).map(([key, value]) => {
            if (typeof value === "object") {
              const userTotalMessages = Object.values(value).reduce(
                (total, count) => total + count,
                0
              );

              return (
                <div key={key} className="custom-card px-4 mb-4">
                  <CardForUsers
                    statTitle={key}
                    messageTypes={{
                      "Total Messages": userTotalMessages,
                      ...value,
                    }}
                    statIconName="fas fa-user"
                    statIconStyle="bg-green-500"
                    statTitleColor="text-red-500"
                  />
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>
    </div>
  );
};

export default UserMessageCounts;
